var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"min-height":"80vh"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }